import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import { Button, Modal } from "react-bootstrap";
import logo from "../../../images/logo.png";
import logoText from "../../../images/logo-text.png";
import { useHistory } from "react-router-dom";

const NavHader = () => {
   const history = useHistory()
   const [toggle, setToggle] = useState(true);
   const [showPopup, setShowPopup] = useState(false);
   const goToPage = (page) =>{
      if(page == 'sms'){
         history.push("/sms-list");
      }
      if(page == 'ticket'){
         history.push("/ticket-list");
      }
      if(page == 'note'){
        history.push("/note-list");
     }
     if(page == 'contact'){
      history.push("/contact-list");
   }

   if(page == 'customer'){
    history.push("/customer-list");
 }
      setShowPopup(false)
   }
   return (
      <div className="nav-header">
         <div className="brand-logo" style={{cursor : "pointer"}} onClick={() => setShowPopup(true)}>
            <img className="logo-abbr" src={logo} alt="" />
            {/* <img className="logo-compact" src={logoText} alt="" />
            <img className="brand-title" src={logoText} alt="" /> */}
         </div>

         <div className="nav-control" onClick={() => setToggle(!toggle)}>
            <div className={`hamburger ${!toggle ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
         <Modal className="modal fade" show={showPopup}>
            <div className="">
              <div className="modal-header" style={{backgroundColor : "#FE634E"}}>
                <h5 className="modal-title">Go To:</h5>
                <Button
                  variant=""
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => setShowPopup(false)}
                >
                  <span>×</span>
                </Button>
              </div>
              <div className="modal-body" style={{textAlign : "center"}}>
                <form
                  className="comment-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    // this.setState({ newEvent: false });
                  }}
                >
                  <div>
                    <div className="form-group">
                      <div className="form-group menuPopupMainDiv">

                      <div className="menuPopupSubDiv" onClick={() => goToPage("sms")}>
                      <i className="flaticon-381-smartphone-5 iconSize"></i><strong className="iconSize1">BG SMS ( {localStorage.getItem("unreadSmsCount") ? localStorage.getItem("unreadSmsCount") : 0} )</strong>
                     </div>
                     <div className="menuPopupSubDiv" onClick={() => goToPage("ticket")}>
                     <i className="flaticon-381-networking iconSize"></i> <strong className="iconSize1">BG Mail Desk ( {localStorage.getItem("unreadTicketCount") ? localStorage.getItem("unreadTicketCount") : 0} )</strong>
                     </div>
                     <div className="menuPopupSubDiv" onClick={() => goToPage("contact")}>
                     <i className="flaticon-381-smartphone-2 iconSize"></i><strong className="iconSize1">BG Contacts ( {localStorage.getItem("unreadContactCount") ? localStorage.getItem("unreadContactCount") : 0} )</strong>
                     </div>
                     <div className="menuPopupSubDiv" onClick={() => goToPage("customer")}>
                     <i className="flaticon-381-user-4 iconSize"></i><strong className="iconSize1">BG Customer ( {localStorage.getItem("unreadCustomerCount") ? localStorage.getItem("unreadCustomerCount") : 0} )</strong>
                     </div>
                     <div className="menuPopupSubDiv" onClick={() => goToPage("note")}>
                     <i className="flaticon-381-note iconSize"></i> <strong className="iconSize1">BG Notes ( {localStorage.getItem("unreadNoteCount") ? localStorage.getItem("unreadNoteCount") : 0} )</strong>
                     </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
      </div>
   );
};

export default NavHader;
